// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"CareerPathWrapper_card-wrapper__pxT6h","mySwiper":"CareerPathWrapper_mySwiper__v_pTG"};